import React, { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import PlusIcon from "../../../../assets/icons/PlusIcon";
import Spinner from "../../../../assets/icons/Spinner";
import label from "../../../../i18n/label";
import Message from "../../../../i18n/Message";

import ModalDialog from "../../../shared/ModalDialog";
import { createAssistant } from "../store/assistantActionCreators";
import { linkToAssistant } from "../../../../routes";
import { currentModelDescriptions } from "../../../../model/model-providers/modelDescriptors";

const CreateAssistantDialog = ({ onClose }) => {
  const dispatch = useDispatch();
  const intl = useIntl();
  const nav = useNavigate();
  const { workspaceId } = useParams();
  const [loading, setLoading] = useState(false);
  const [name, setName] = useState("");
  const [input, setInput] = useState(null);
  const [formElem, setFormElem] = useState(null);

  useEffect(() => {
    if (input) input.focus();
  }, [input]);

  const onCreate = () => {
    const valid = input.checkValidity();
    if (formElem) formElem.reportValidity();
    if (!valid) return;
    setLoading(true);
    const onSuccess = (assistant) => {
      setLoading(false);
      onClose();
      nav(linkToAssistant(workspaceId, assistant.uid));
    };
    const onError = () => {
      setLoading(false);
    };
    // Set default modelId to the first model from currentModelDescriptions
    const defaultModelId = currentModelDescriptions[0]?.id || null;
    dispatch(
      createAssistant(
        intl,
        workspaceId,
        {
          name,
          modelId: defaultModelId,
          systemPrompt:
            "You are a helpful AI assistant. Follow the user's instructions carefully. Respond using markdown.",
        },
        onSuccess,
        onError
      )
    );
  };

  const onSubmit = (e) => {
    e.preventDefault();
    onCreate();
  };

  return (
    <ModalDialog onClose={onClose} className="create_campaign_dialog">
      <div className="modal_title">
        <Message id="create_assistant" />
      </div>
      <form onSubmit={onSubmit} ref={(val) => setFormElem(val)}>
        <div className="campaign_form">
          <div className="dialog_body">
            <input
              className="form-control"
              type="text"
              ref={(val) => setInput(val)}
              required
              maxLength="120"
              placeholder={label(intl, "assistant_name_placeholder")}
              onChange={(e) => setName(e.target.value)}
              value={name}
              readOnly={loading}
            />
          </div>
        </div>
        <div className="buttons">
          <button
            className="btn bg-gradient-dark"
            type="submit"
            disabled={loading}
          >
            {loading ? (
              <Spinner size="18" />
            ) : (
              <PlusIcon color="#fff" strokeWidth="2" size="18" />
            )}
            <Message id="create_assistant_button" />
          </button>
          <button className="btn no-btn" onClick={onClose} type="button">
            <Message id="cancel" />
          </button>
        </div>
      </form>
    </ModalDialog>
  );
};

export default CreateAssistantDialog;
